import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestClilentCompany {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 订单主键
     */
    OrderId?: string;
    /**
     * 服务类型
     */
    Service?: EnumOrderServiceType;
}

/**
 * -表单校验
 */
export const DtoRequestClilentCompanyRules = {
}
